import Vuex from "vuex";
import Vue from "vue";
//1. 安装
Vue.use(Vuex);
var store = new Vuex.Store({
    state: {
        supUser:{
            // roleId:1 //0是主账号 1子账号
        } 
    },
    mutations: {
        updataRole(state,value) {
            //变更状态
            state.supUser=value
        }
    }
});

export default store;